// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
	{ path: 'auth', loadChildren: 'app/modules/management/auth/auth.module#AuthModule' },
	{ path: 'landing', loadChildren: 'app/modules/management/landing/landing.module#LandingModule' },
	// { path: 'campaign', loadChildren: 'app/modules/management/campaign/campaign.module#CampaignModule' },
	{ path: 'festival', loadChildren: 'app/modules/management/festival/festival.module#FestivalModule' },
	{ path: '', redirectTo: 'account', pathMatch: 'full' },
	{ path: 'account', loadChildren: 'app/modules/management/account/account.module#AccountModule' },
	{ path: 'admin', loadChildren: 'app/modules/management/admin/admin.module#AdminModule' },
	{ path: 'purchase', loadChildren: 'app/modules/management/purchase/purchase.module#PurchaseModule' },
	{ path: '**', redirectTo: 'default/error/403', pathMatch: 'full' },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
